import request from './request'

export function search(data) {
    return request({
        url: '/api/bbx/list',
        method: 'get',
        params: data
    })
}

export function deleteById(data) {
    return request({
        url: '/api/bbx/delete',
        method: 'post',
        data: data
    })
}